firebird.factory('videoStatsService', [
    '$rootScope',
    '$timeout',
    '$interval',
    '$window',
    'logService',
    'connectivityService',
    'socketService',
    'attendeeListService',
    'helperService',
    'meetingService',
    'msgFlowFactory',
    'videoFilterService',
    'configService',
    'avDeviceService',
    'videoGlobalService',
    function (
        $rootScope,
        $timeout,
        $interval,
        $window,
        logService,
        connectivityService,
        socketService,
        attendeeListService,
        helperService,
        meetingService,
        msgFlowFactory,
        videoFilterService,
        configService,
        avDeviceService,
        videoGlobalService
    ) {
        var service = {
            initialize: initialize
        };

        var self, $scope;

        const logger = new LogServiceWrapper(logService, '[videoroomCtrl] videoStatsService');

        return service;

        function initialize(selfParam) {
            self = selfParam;
            $scope = videoGlobalService.data.$scope;

            if (videoGlobalService.test) {
                $window = videoGlobalService.data.$window;
            }

            self.initStats = initStats;

            self.calculateMediaQualityMetrics = calculateMediaQualityMetrics;
            self.cdrDebug = false; // if true, log formatted CDR data in client and server for this attendee. if 'client', then log in client unformatted.
            self.cdrAudioChanged = false; // if audio got enabled in a reporting interval, for CDR purpose.
            self.cdrAudioEnabled = false; // if audio is currently enabled or not, for CDR purpose.
            self.statsReduce = false; // if true, then do not get stats unless the video is enabled.

            self.gpuName = undefined;
            self.gpuNameDefined = false;

            // message flow
            /** @type {MsgFlow} */
            self.msgflow = msgFlowFactory.createContext({});
            if (self.msgflow) {
                self.msgflow.instanceId = self.instanceId;
                self.msgflow.session = meetingService.getMeetingCode();
            }
            self.msgflowEvent = msgflowEvent;
            self.appinsight = {};

            // connectivity stats toggle
            $scope.$on('toggle-connection-stats', onToggleConnectivityStats);

            $scope.$on('request-metrics-video-room', addVideoroomDataToModel);

            self.lastCpuMetricData = null;
            self.simulateDummyCpuMetricsTimer = null;
            self.simulateDummyCpuMetricsData = {
                cpu: 50,
                cpuLoadTotal: 50,
                cpuModel: 'ARM',
                memory: 1000,
                memoryTotal: 1000,
                gpu: 20,
                gpuMemory: 200
            };
            self.startSimulateDummyCpuMetrics = startSimulateDummyCpuMetrics;
            self.stopSimulateDummyCpuMetrics = stopSimulateDummyCpuMetrics;
            self.addStatsPerformanceMetric = addStatsPerformanceMetric;

            $scope.$on('received-cpu-metrics-video-room', onReceivedCpuMetrics);

            // for sending stats to node server
            self.sendStatsInterval = 10000; // can be altered with URL param.
            self.sendStatsAllowForced = false; // if true, invoke on pc start/end, but causes more getStats calls.
            self.sendStatsLast = null; // last stats at sendStatsTime
            self.sendStatsTime = null; // last time onSendStatsTimeout was invoked, or 0 for none
            self.sendStatsTimer = null; // interval timer
            self.sendStatsTotal = null; // cumulative results, what is actually sent to server
            self.onSendStatsTimeout = onSendStatsTimeout;
            self.startSendStats = startSendStats;
            self.stopSendStats = stopSendStats;
            self.sendStatsUpdate = sendStatsUpdate;
            self.sendStatsExternal = sendStatsExternal;
            self.sendStatsLastId = 0;
            self.sendStatsCheckAudioReceive = sendStatsCheckAudioReceive;
            self.sendStatsAudioRxCount = 0; // if 0 bytes received in last max=2 stats cycle, then reconnect audio
            self.sendStatsAudioRxMax = 2;

            self.showStatsDisplay = false;
            // do not remove these yet: non-redesign stats display still uses them.
            self.showVideoTxCandidates = false;
            self.showScreenTxCandidates = false;
            self.showAudioTxCandidates = false;
            self.statsResults = null;
            self.statsTimer = null;
            self.statsTimeoutPending = false;
            self.toggleStatsDisplay = toggleStatsDisplay;
            self.showStatsDisplayOnce = showStatsDisplayOnce;
            self.toggleStatsMore = toggleStatsMore;
            self.onStatsTimeout = onStatsTimeout;

            self.setConfigObjectFromCSV = setConfigObjectFromCSV;
            self.onToggleConnectivityStats = onToggleConnectivityStats;
            self.statsLast = {};

            self.statsFinalizeResult = statsFinalizeResult;

            // whether to use inbound-rtp and outbound-rtp for deprecated track attributes in chrome 109+
            self.isGetStatsTrackMetricDeprecated = false;
        }

        // update stats from URL param
        function initStats() {
            // sendStats
            var sendStats = configService.getClientValue('sendStats');
            if (sendStats) {
                if (sendStats == 'false' || sendStats == '0') {
                    self.sendStatsInterval = 0;
                } else {
                    sendStats = parseInt(sendStats);
                    if (!isNaN(sendStats) && sendStats > 0) {
                        self.sendStatsInterval = sendStats;
                    }
                }
            }

            // cdrDebug can be turned on by url param
            var cdrDebug = configService.getValue('cdrDebug');
            if (cdrDebug) {
                self.cdrDebug = cdrDebug == 'true' ? true : cdrDebug == 'false' ? false : cdrDebug;
            }

            // stats reduce
            self.statsReduce = configService.getValue('statsReduce') == 'true'; // default is false

            // these attributes are similar to what is used for Simulcast check, and works reliably.
            self.isGetStatsTrackMetricDeprecated =
                $window.Janus.webRTCAdapter.browserDetails.browser === 'chrome' &&
                $window.Janus.webRTCAdapter.browserDetails.version >= 109;

            if (configService.getClientValue('simulateCpuMetric') == 'true') {
                self.startSimulateDummyCpuMetrics();
            }
        }

        function setVideoParameters(data) {
            data.videoPublished = !!self.mystream;
            if (data.videoPublished) {
                var videoTrack = self.mystream.getVideoTracks()[0];
                if (videoTrack) {
                    data.videoParameters = Object.assign(self.appinsight.videoParameters || {}, {
                        cameraName: videoTrack.label
                    });
                }
            }
        }

        function setScreenshareParameters(data) {
            data.isScreenSharing = !!self.screenstream;
            if (data.isScreenSharing) {
                data.screenshareParameters = self.appinsight.screenshareParameters;
            }
        }

        function getVideoroomData() {
            var data = {};
            setVideoParameters(data);
            setScreenshareParameters(data);

            // Number of videos received
            data.numberVideos = $window.$('#videoroom-videos > div.remote[enable="true"]:not(.audioonly)').length;

            // Video layout mode
            data.layout = $window.$('#videoroom-videos[hasspotlight]').length > 0 ? 'spotlight' : 'grid';

            // Video codec used
            data.videocodec = self.videocodec ? self.videocodec : 'vp8';

            data.windowHeight = $window.window.outerHeight;
            data.windowWidth = $window.window.outerWidth;
            return data;
        }

        function addVideoroomDataToModel(event, data) {
            data.videoroomData = getVideoroomData();
            if (!self.gpuNameDefined) {
                self.gpuName = getGpuName();
                self.gpuNameDefined = true;
            }
            data.gpuName = self.gpuName;
            data.email = self.email;

            $rootScope.$broadcast('metrics-video-room', data);
        }

        function getGpuName() {
            try {
                if (window.WebGLRenderingContext || window.WebGL2RenderingContext) {
                    var canvasElement = document.createElement('canvas');
                    var canvasContext =
                        canvasElement.getContext('webgl2') ||
                        canvasElement.getContext('webgl') ||
                        canvasElement.getContext('experimental-webgl2') ||
                        canvasElement.getContext('experimental-webgl');
                    var supportedExtensions = canvasContext.getSupportedExtensions();
                    if (supportedExtensions.indexOf('WEBGL_debug_renderer_info') >= 0) {
                        var rendererInfo = canvasContext.getParameter(
                            canvasContext.getExtension('WEBGL_debug_renderer_info').UNMASKED_RENDERER_WEBGL
                        );
                        if (rendererInfo.indexOf('ANGLE (') >= 0) {
                            rendererInfo = rendererInfo.slice(7, -1);
                            return rendererInfo;
                        } else {
                            return rendererInfo === 'Google SwiftShader' ? undefined : rendererInfo;
                        }
                    }
                }
            } catch (e) {
                logger.error('getGpuName', 'unable to get GPU name', e);
            }

            return undefined;
        }

        // convinience function instead of having to null check at every place.
        function msgflowEvent(text, data) {
            if (self.msgflow) {
                self.msgflow.event(text, data);
            }
        }

        function startSendStats() {
            if (!self.sendStatsTimer) {
                self.sendStatsLast = {};
                self.sendStatsResults = {};
                self.sendStatsTime = 0;
                self.sendStatsTotal = {};
                self.onSendStatsTimeout();
                self.sendStatsTimer = $interval(self.onSendStatsTimeout, self.sendStatsInterval);
            }
        }

        function stopSendStats() {
            if (self.sendStatsTimer) {
                $interval.cancel(self.sendStatsTimer);
                self.sendStatsTimer = null;
            }
            self.sendStatsTime = null;
            self.sendStatsTotal = null;
        }

        function onSendStatsTimeout() {
            var interval = self.sendStatsInterval;
            var now = new Date().getTime();
            var previous = self.sendStatsTime;

            if (self.sendStatsAllowForced) {
                // calculate actual interval based on when last time invoked
                interval = now - (self.sendStatsTime || now);
                if (interval > self.sendStatsInterval * 0.95 && interval < self.sendStatsInterval * 1.05) {
                    // allow 5% error margin in invoking timer
                    interval = self.sendStatsInterval;
                }
                if (interval < 500) {
                    // do not use interval if too small.
                    interval = 0;
                }
            } // else assume interval is fixed

            self.sendStatsTime = now;

            const firstTimeStats = Object.keys(self.sendStatsLast || {}).length == 0;
            self.calculateMediaQualityMetrics(
                self.sendStatsLast,
                function (result) {
                    if (!self.qualityStats.timer) {
                        self.combineAndSendQualityBarsData(result, 'sendStats');
                    } // otherwise, it is used from onQualityStatsTimeout
                    if (!firstTimeStats) {
                        if (self.adjustOnAvailableBandwidth) {
                            result.forEach(function (item) {
                                if (
                                    item.media == 'video' &&
                                    !item.screen &&
                                    item.candidatePairs &&
                                    item.candidatePairs.length > 0
                                ) {
                                    var availableBitrate = item.availableBitrate || getAvailableBitrate(item);
                                    self.updateAvailableVideoBitrate(
                                        item.attendee,
                                        item.dir == 'outbound',
                                        availableBitrate
                                    );
                                }
                                if (item.candidatePairs) {
                                    // delete, so that not sent to the server in stats.
                                    delete item.candidatePairs;
                                }
                            });
                        }
                        if (
                            self.qualityLimitation.enabled ||
                            (self.useEncodeTime && self.videoLowState.encodeTime === undefined)
                        ) {
                            result.forEach(function (item) {
                                //// TODO: keep this code for testing in dev mode.
                                // if (item.media == 'video' && item.dir == 'outbound') {
                                //     item.qualityLimitationResolutionChanges = self._somevalue = (self._somevalue || 0) + 1;
                                //     console.info('qualityLimitationResolutionChanges=' + item.qualityLimitationResolutionChanges);
                                // }
                                if (item.media == 'video' && item.dir == 'outbound' && !item.screen) {
                                    self.checkVideoLowInWebcamStats(item);
                                }
                            });
                        }

                        var data;
                        if (previous) {
                            // if audio is currently enabled, or was enabled at all in this interval.
                            if (self.cdrAudioEnabled || self.cdrAudioChanged) {
                                self.cdrAudioChanged = false; // reset after use.
                            } else {
                                // do not include audio Tx records.
                                result = result.filter(function (item) {
                                    return !(item.media == 'audio' && item.dir == 'outbound');
                                });
                            }

                            if (self.mediapath != 'sfu') {
                                self.sendStatsCheckAudioReceive(result);
                                if (self.videoroom) {
                                    videoFilterService.videoFilterCheckStatsSend(result);
                                }
                            }

                            data = { start: previous, end: now, interval: interval, items: result };

                            if (self.cdrDebug === true) {
                                logService.log('sending attendee-mediastats\n' + JSON.stringify(data, null, ' '));
                            } else if (self.cdrDebug == 'client') {
                                logService.log('sending attendee-mediastats ' + JSON.stringify(data)); // No formatting for remote log
                            }
                        } else {
                            data = { bandwidthUp: self.speedtestBwUp, bandwidthDown: self.speedtestBwDown };
                            if (self.cdrDebug === true) {
                                data.debug = true;
                            }
                            logService.log('sending attendee-mediastats\n' + JSON.stringify(data));
                        }
                        socketService.send({
                            message: 'attendee-mediastats',
                            data: data
                        });
                        saveParametersForAppInsight(result);
                    }
                    // mark audio peer connection with whether data is sent/received yet or not.
                    const plugin = self.sipcall;
                    if (plugin && !plugin.receiveInitiated) {
                        plugin.receiveInitiated = result.some(
                            item => item.media == 'audio' && item.dir == 'inbound' && item.bytes > 0
                        );
                    }
                },
                {
                    interval: interval,
                    candidates: !!self.adjustOnAvailableBandwidth,
                    bytes: 'raw',
                    firsttime: true,
                    flat: true,
                    fixframerate: true,
                    cumulative: false,
                    checkFrozen: true,
                    checkPath: true,
                    checkSource: true,
                    qualityBar: !self.qualityStats.timer,
                    sendstats: !!self.msgflow
                }
            );
            // TODO: ideally firsttime should be true, but causes wrong stats of first time.
        }

        function saveParametersForAppInsight(result) {
            result.forEach(function (item) {
                if (item.dir === 'outbound' && item.media === 'video') {
                    var parameters = {
                        width: item.frameWidth,
                        height: item.frameHeight,
                        frameRate: item.frameRate
                    };
                    if (item.screen) {
                        self.appinsight.screenshareParameters = parameters;
                    } else {
                        self.appinsight.videoParameters = parameters;
                    }
                }
            });
        }

        function onReceivedCpuMetrics(e, transformed) {
            self.lastCpuMetricData = transformed;
        }

        function startSimulateDummyCpuMetrics() {
            self.stopSimulateDummyCpuMetrics();
            const handler = function () {
                for (let attr in self.simulateDummyCpuMetricsData) {
                    let value = self.simulateDummyCpuMetricsData[attr];
                    if (typeof value === 'number') {
                        value = value + Math.round((Math.random() - 0.5) * (value * 0.05));
                        if (value < 0) {
                            value = 10;
                        } else if (value >= 100 && (attr === 'cpu' || attr === 'cpuLoadTotal' || attr === 'gpu')) {
                            value = 80;
                        }
                        self.simulateDummyCpuMetricsData[attr] = value;
                    }
                }

                self.lastCpuMetricData = JSON.parse(JSON.stringify(self.simulateDummyCpuMetricsData));
            };

            self.simulateDummyCpuMetricsTimer = $interval(handler, 30000);
            handler();
        }

        function stopSimulateDummyCpuMetrics() {
            if (self.simulateDummyCpuMetricsTimer) {
                $interval.cancel(self.simulateDummyCpuMetricsTimer);
                self.simulateDummyCpuMetricsTimer = null;
            }
        }

        function sendStatsUpdate(on, plugin) {
            if (self.sendStatsTimer) {
                if (plugin.state) {
                    if (on) {
                        plugin.state.startTime = new Date().getTime(); // used in framerate and bitrate calculation for first interval
                    } else {
                        delete plugin.state.startTime;
                    }
                }
                if (self.sendStatsAllowForced) {
                    self.onSendStatsTimeout();
                }
            }
        }

        // Inspired from  https://github.com/fippo/rtcstats/blob/master/rtcstats.js
        function sendStatsExternal(index, pc, reports, startTime, plugin) {
            if (self.msgflow && pc && pc._createData) {
                try {
                    // for first time, send create also.
                    if (!pc._createData.id) {
                        pc._createData.url = $window.location.href;
                        pc._createData.start = startTime || Date.now();
                        pc._createData.id = self.instanceId + '-' + ++self.sendStatsLastId;
                        var sanitize = function (value) {
                            return (value || '').replace(/[^a-zA-Z0-9_\-@\.\ ]/, '?').substr(0, 32);
                        };
                        pc._createData.attendee = {
                            name: sanitize(self.name),
                            email: sanitize(self.email),
                            host: self.isHost || undefined
                        };
                        //ANYAM-73916: Include User Flags in MsgFlow event, only once per PeerConnection creation
                        if (self.flagsObject) {
                            if (index === 'audio') {
                                var clonedFlagsObj = Object.assign({}, self.flagsObject);
                                delete clonedFlagsObj.enableAutoPerformanceMode;
                                delete clonedFlagsObj.videoFilter;
                                pc._createData.flags = clonedFlagsObj;
                            } else {
                                pc._createData.flags = self.flagsObject;
                            }
                        }

                        self.msgflow.create(index, pc._createData.id, pc, plugin, pc._createData);
                    }

                    // add CPU usage stats in reports if on unite/electron, and CPU usage is available.
                    if (
                        index === 'audio' &&
                        (helperService.isElectron() ||
                            helperService.isUniteApplication() ||
                            self.simulateDummyCpuMetricsTimer)
                    ) {
                        reports = self.addStatsPerformanceMetric(reports);
                    }

                    //console.log('sendStatsExternal ' + index);
                    self.msgflow.stats(index, pc._createData.id, pc, plugin, reports);
                } catch (e) {
                    logger.warn('sendStatsExternal', 'Error', e);
                }
            } // else no where to send stats or missing data, ignore.
        }

        function addStatsPerformanceMetric(reports) {
            if (self.lastCpuMetricData) {
                let newReports = [];
                reports.forEach(item => {
                    newReports.push(item);
                });
                if (newReports.length > 0) {
                    const oneReport = {
                        id: 'Performance',
                        type: 'performance',
                        timestamp: newReports[0].timestamp
                    };
                    newReports.push(Object.assign(oneReport, self.lastCpuMetricData));
                    self.lastCpuMetricData = null;
                    return newReports;
                }
            }
            return reports;
        }

        // ANYAM-67656 - reconnect audio peer connection when audio stops receiving for couple iterations.
        function sendStatsCheckAudioReceive(result) {
            if (
                !self.sipcall ||
                !self.sipcall.state ||
                !(self.sipcall.state.ice == 'completed' || self.sipcall.state.ice == 'connected') ||
                self.sipcall.sipReconnectTimeout || // reconnection in progress
                connectivityService.getIsPhoneOnly() ||
                connectivityService.getAudioThroughPhone()
            ) {
                // not using local audio or not yet ICE connected.
                self.sendStatsAudioRxCount = 0;
                return;
            }

            var list = result
                .filter(function (item) {
                    return item.media == 'audio' && item.dir == 'inbound';
                })
                .map(function (item) {
                    return item.bytes;
                });

            if (!list || list.length == 0) {
                //no peer connection yet
                self.sendStatsAudioRxCount = 0;
                return;
            }

            var audioRx = list.reduce(function (sum, value) {
                return sum + value;
            }, 0);

            if (audioRx > 0) {
                // received bytes, reset counter
                self.sendStatsAudioRxCount = 0;
                return;
            }

            // received 0 bytes in this cycle, increment counter
            self.sendStatsAudioRxCount++;

            var count = self.sendStatsAudioRxCount;
            var reconnect = false;

            if (self.sendStatsAudioRxCount >= self.sendStatsAudioRxMax) {
                // trigger ice restart, and reset counter
                reconnect = true;
                self.sendStatsAudioRxCount = 0;
                self.sipcall.state.ice = 'disconnected';
                self.iceRestartAfter(self.sipcall, 'audio', undefined, 500); // reduce timeout to 0.5s
            }

            logger.warn(
                'sendStatsCheckAudioReceive',
                'checkAudioReceive - no bytes for ' + count + ' intervals, reconnect=' + reconnect
            );
        }

        // for stats display

        function onToggleConnectivityStats(evt, data) {
            if (data.shiftKey) {
                self.toggleStatsDisplay();
            } else if (helperService.getIsRedesign()) {
                $rootScope.$broadcast('showhide-feature-flags');
            }
        }

        function toggleStatsDisplay() {
            if (self.statsTimer || self.showStatsDisplay) {
                self.showStatsDisplay = false;
                self.statsResults = null;
                if (self.statsTimer) {
                    $interval.cancel(self.statsTimer);
                    self.statsTimer = null;
                }
                self.statsLast = {};
                digest();
            } else {
                self.statsLast = {};
                self.showStatsDisplay = true;
                self.statsResults = {};
                digest();

                $timeout(function () {
                    $window.$('#videoroom-stats').draggable({
                        handle: $window.$('#videoroom-stats .handle')
                    });
                }, 100);

                self.onStatsTimeout();
                self.statsTimer = $interval(self.onStatsTimeout, 1000);
            }
        }

        // display stats value without periodic timer.
        function showStatsDisplayOnce(value) {
            if (!self.statsTimer) {
                self.showStatsDisplay = true;
                self.statsResults = value;
                digest();

                $timeout(function () {
                    $window.$('#videoroom-stats').draggable({
                        handle: $window.$('#videoroom-stats .handle')
                    });
                }, 100);
            }
        }

        // Toggle the expanded="true" attribute of the stats display row-wrapper element.
        // If shiftKey is pressed, then apply to all the row-wrapper elements.
        function toggleStatsMore(event) {
            var source = $window.$(event.currentTarget).parent().parent();
            var target = !event.shiftKey ? source : source.parent().children('.row-wrapper');
            if (source.attr('expanded') != 'true') {
                target.attr('expanded', 'true');
            } else {
                target.removeAttr('expanded');
            }
        }

        function statsSetLocalPeerConnectionData(peerConnectionsData) {
            if (self.sipcall) {
                peerConnectionsData[self.attendantId + '-audio'] = {
                    media: 'audio',
                    pc: self.sipcall.webrtcStuff && self.sipcall.webrtcStuff.pc,
                    start: self.sipcall.state.startTime
                };
            }
            if (self.videoroom) {
                peerConnectionsData[self.attendantId + '-video'] = {
                    media: 'video',
                    direction: 'send',
                    bitrate: self.getVideoBitrate(),
                    pc: self.sipcall.webrtcStuff && self.videoroom.webrtcStuff.pc,
                    start: self.videoroom.state.startTime
                };
            }
            if (self.screenshare) {
                peerConnectionsData[self.attendantId + '-screen'] = {
                    media: 'video',
                    direction: 'send',
                    bitrate: self.getVideoBitrate(true),
                    pc: self.sipcall.webrtcStuff && self.screenshare.webrtcStuff.pc,
                    start: self.screenshare.state.startTime
                };
            }
        }

        function statsSetRemotePeerConnectionData(peerConnectionsData, interval, now) {
            // do not use :not(.audioonly) in selector, to get stats even for audio only video element for mediapath=sfu

            $window.$('#videoroom-videos > div').each(function (index, videoDiv) {
                if (videoDiv.remoteFeed) {
                    var disabled = $window.$(videoDiv).attr('enable') == 'false';
                    if (self.statsReduce && disabled) {
                        // do not process disabled video rx for stats.
                        return;
                    }

                    var simulcast = null;
                    var veItem = $window.$(videoDiv);
                    var minimized = veItem.attr('minimized');
                    var substream = veItem.attr('substream');
                    var temporal = veItem.attr('temporal');
                    var parts = (veItem.attr('simulcast') || ',').split(',');
                    if (
                        videoDiv.remoteFeed.simulcastStarted &&
                        !self.simulcastToggleState.restricted &&
                        (substream !== undefined || temporal !== undefined)
                    ) {
                        simulcast = [
                            parts[0],
                            parts[1],
                            substream !== undefined ? substream : '',
                            temporal !== undefined ? temporal : ''
                        ];
                    }
                    var id = veItem.attr('user');
                    if (self.refactorPublisherId) {
                        id = id.replace(/\-/g, ''); // using - will cause problem.
                    }

                    if (!videoDiv.remoteFeed.state.startTime) {
                        // workaround for 'switch' on allhands.
                        videoDiv.remoteFeed.state.startTime = now - interval;
                    }

                    var displayname = veItem.attr('displayname');
                    var plugin =
                        (self.layoutPage &&
                            self.layoutPageReuse.enabled &&
                            videoDiv.remoteFeed._plugin &&
                            videoDiv.remoteFeed._plugin._pendingId) ||
                        null;
                    peerConnectionsData[id + '-video'] = {
                        media: 'video',
                        direction: 'recv',
                        simulcast: simulcast,
                        pc: videoDiv.remoteFeed.webrtcStuff && videoDiv.remoteFeed.webrtcStuff.pc,
                        plugin: plugin || undefined,
                        displayname: displayname,
                        start: videoDiv.remoteFeed.state.startTime,
                        spotlight: self.maxvideo === videoDiv,
                        paused: videoDiv.remoteFeed.paused || self.isVideoTogglePaused(videoDiv.remoteFeed.isScreen),
                        minimized: !!minimized,
                        disabled: disabled
                    };
                }
            });
        }

        function statsCleanObsoleteKeys(statsData, currentKeys) {
            if (statsData) {
                for (var statsKey in statsData) {
                    if (currentKeys.indexOf(statsKey) < 0) {
                        delete statsData[statsKey];
                    }
                }
            }
        }

        function statsGetStatsFromPConnectionReport(reports, options) {
            var stats = {};
            if (options.candidates !== false) {
                stats.candidatePairs = [];
            }

            var outboundRtpAttr = [
                'bytesSent',
                'firCount',
                'pliCount',
                'nackCount',
                'qpSum',
                'framesEncoded',
                'packetsSent',
                'totalEncodeTime'
            ];
            var inboundRtpAttr = [
                'bytesReceived',
                'firCount',
                'pliCount',
                'nackCount',
                'packetsReceived',
                'packetsLost',
                'framesDecoded',
                'jitter',
                'totalDecodeTime',
                'framesReceived',
                'framesDropped',
                'totalAudioEnergy'
            ];
            var videoTrackAttr = ['frameWidth', 'frameHeight', 'framesSent'];
            var audioTrackAttr = ['jitterBufferDelay', 'jitterBufferEmittedCount'];
            var rtpAttrSum = ['framesSent', 'jitterBufferDelay', 'jitterBufferEmittedCount'];
            var rtpAttrMax = ['frameWidth', 'frameHeight'];
            var localCandidateAttr = ['ip', 'networkType', 'port', 'protocol', 'candidateType'];
            var remoteCandidateAttr = ['ip', 'networkType', 'port', 'protocol', 'candidateType'];

            var codecs = {}; // id to name
            reports.forEach(function (report) {
                if (report.type == 'codec') {
                    codecs[report.id] = report.mimeType;
                }
            });

            const captureTrackAttrFromRtp = function (report, stats) {
                rtpAttrSum.forEach(function (attr) {
                    if (report[attr] !== undefined) {
                        stats[attr] = (stats[attr] || 0) + (report[attr] || 0);
                    }
                });
                rtpAttrMax.forEach(function (attr) {
                    if (report[attr] !== undefined) {
                        stats[attr] = Math.max(stats[attr] || 0, report[attr]);
                    }
                });
            };

            reports.forEach(function (report) {
                // // TODO: uncomment this to print the raw reports.
                // if (index == (self.attendantId + '-video')) {
                //     logService.log(report);
                // }

                if (report.type == 'outbound-rtp') {
                    outboundRtpAttr.forEach(function (attr) {
                        if (report[attr] !== undefined) {
                            stats[attr] = (stats[attr] || 0) + report[attr];
                        }
                    });
                    if (report.codecId !== undefined) {
                        stats[report.mediaType + 'codecOut'] = (codecs[report.codecId] || '').split('/')[1];
                    }

                    stats.bytesSentTotal = stats.bytesSent || 0;
                    stats.qualityLimitationReason = report.qualityLimitationReason || undefined;
                    stats.qualityLimitationResolutionChanges = report.qualityLimitationResolutionChanges || 0;

                    if (self.isGetStatsTrackMetricDeprecated) {
                        captureTrackAttrFromRtp(report, stats);
                    }
                } else if (report.type == 'inbound-rtp') {
                    inboundRtpAttr.forEach(function (attr) {
                        if (report[attr] !== undefined) {
                            stats[attr] = (stats[attr] || 0) + report[attr];
                        }
                    });
                    if (report.codecId !== undefined) {
                        stats[report.mediaType + 'codecIn'] = (codecs[report.codecId] || '').split('/')[1];
                    }

                    stats.bytesReceivedTotal = stats.bytesReceived || 0;

                    if (self.isGetStatsTrackMetricDeprecated) {
                        captureTrackAttrFromRtp(report, stats);
                    }
                } else if (report.type == 'track' && report.kind == 'video' && !report.ended) {
                    if (!self.isGetStatsTrackMetricDeprecated) {
                        videoTrackAttr.forEach(function (attr) {
                            if (report[attr] !== undefined) {
                                stats[attr] = (stats[attr] || 0) + report[attr];
                            }
                        });
                    }
                } else if (report.type == 'track' && report.remoteSource && report.kind == 'audio' && !report.ended) {
                    if (!self.isGetStatsTrackMetricDeprecated) {
                        audioTrackAttr.forEach(function (attr) {
                            stats[attr] = (stats[attr] || 0) + (report[attr] || 0);
                        });
                    }
                } else if (report.type == 'remote-inbound-rtp') {
                    stats.fractionLost = report.fractionLost; // from RTCP RR. appears to be undefined always.
                    stats.sentPacketsLost = (stats.sentPacketsLost || 0) + (report.packetsLost || 0);
                    stats.sentJitter = (stats.sentJitter || 0) + (report.jitter || 0);
                    stats.rttDelay = (stats.rttDelay || 0) + Math.round(500 * report.roundTripTime); // 1000/2 * RTT
                    stats.rttDelayAvg =
                        (stats.rttDelayAvg || 0) +
                        Math.round((500 * (report.totalRoundTripTime || 0)) / (report.roundTripTimeMeasurements || 1));
                } else if (report.type == 'media-source') {
                    if (report.kind == 'audio') {
                        stats.audioSource = (stats.audioSource || 0) + 1;
                    } else if (report.kind == 'video') {
                        stats.videoSource = (stats.videoSource || 0) + 1;
                        stats.fpsCapture = report.framesPerSecond;
                        stats.height = report.height;
                        stats.width = report.width;
                    }
                } else if (report.type == 'transport') {
                    stats.candidateChanges = (stats.candidateChanges || 0) + (report.selectedCandidatePairChanges || 0);
                } else if (options.candidates !== false) {
                    if (report.type == 'candidate-pair' && report.nominated == true && report.state == 'succeeded') {
                        var candidatePair = {};

                        if (report.localCandidateId) {
                            candidatePair.localCandidate = {
                                id: report.localCandidateId.replace('RTCIceCandidate_', '')
                            };
                        }

                        if (report.remoteCandidateId) {
                            candidatePair.remoteCandidate = {
                                id: report.remoteCandidateId.replace('RTCIceCandidate_', '')
                            };
                        }

                        if (candidatePair && candidatePair.localCandidate && candidatePair.remoteCandidate) {
                            candidatePair.availableOutgoingBitrate =
                                Math.round((report.availableOutgoingBitrate || 0) / 1000) || undefined;
                            candidatePair.availableIncomingBitrate =
                                Math.round((report.availableIncomingBitrate || 0) / 1000) || undefined;
                            candidatePair.currentRoundTripTime =
                                Math.round(((report.currentRoundTripTime || 0) * 1000) / 2) || undefined;
                            candidatePair.circuitBreakerTriggerCount = report.circuitBreakerTriggerCount || 0;
                            stats.candidatePairs.push(candidatePair);
                        }

                        if (self.brokenMediaPath.detect) {
                            stats.bytesReceivedNetwork =
                                (stats.bytesReceivedNetwork || 0) + (report.bytesReceived || 0);
                        }
                    } else if (report.type == 'local-candidate' && report.id) {
                        stats.candidatePairs.forEach(function (pair) {
                            if (pair.localCandidate && report.id.indexOf(pair.localCandidate.id) > -1) {
                                localCandidateAttr.forEach(function (attr) {
                                    if (report[attr] !== undefined) {
                                        pair.localCandidate[attr] = report[attr];
                                    }
                                });
                            }
                        });
                    } else if (report.type == 'remote-candidate' && report.id) {
                        stats.candidatePairs.forEach(function (pair) {
                            if (pair.remoteCandidate && report.id.indexOf(pair.remoteCandidate.id) > -1) {
                                remoteCandidateAttr.forEach(function (attr) {
                                    if (report[attr] !== undefined) {
                                        pair.remoteCandidate[attr] = report[attr];
                                    }
                                });
                            }
                        });
                    }
                }
            });

            return stats;
        }

        function statsSetResultObj(stats, pc, pcKey, statsLast, options, result) {
            if (statsLast[pcKey] || options.firsttime) {
                var attrSet = new Set([
                    'bytesSent',
                    'packetsSent',
                    'framesSent',
                    'bytesReceived',
                    'packetsReceived',
                    'framesDecoded',
                    'qpSum',
                    'framesEncoded',
                    'totalEncodeTime',
                    'totalDecodeTime',
                    'framesReceived',
                    'framesDropped',
                    'jitterBufferDelay',
                    'jitterBufferEmittedCount',
                    'bytesReceivedNetwork',
                    'totalAudioEnergy'
                ]);
                var anotherSet = new Set([
                    'sentPacketsLost',
                    'packetsLost',
                    'bytesSentTotal',
                    'bytesReceivedTotal',
                    'firCount',
                    'pliCount',
                    'nackCount',
                    'candidateChanges'
                ]);

                var last = statsLast[pcKey] || {};
                result[pcKey] = {};

                if (stats.bytesSent || stats.bytesReceived) {
                    if (
                        (stats.bytesSent && last.bytesSent && stats.bytesSent < last.bytesSent) ||
                        (stats.bytesReceived && last.bytesReceived && stats.bytesReceived < last.bytesReceived)
                    ) {
                        // wrapped, probably due to reconnection within an interval
                        statsLast[pcKey] = last = {};
                    }
                }

                for (var attr in stats) {
                    if (attrSet.has(attr) || (options.cumulative === false && anotherSet.has(attr))) {
                        result[pcKey][attr] = Math.max(0, stats[attr] - (last[attr] || 0)); // min 0, ignore negative value; negative indicates counter was reset.
                    } else {
                        result[pcKey][attr] = stats[attr];
                    }
                }

                if (options.candidates !== false) {
                    //Sometimes candidate pair arrays are empty in one interval, but available in another,
                    //resulting in a "flickering" of these stats in the widget... this prevents that
                    if (
                        last.candidatePairs &&
                        last.candidatePairs.length > 0 &&
                        result[pcKey].candidatePairs.length === 0
                    ) {
                        result[pcKey].candidatePairs = last.candidatePairs;
                    }
                }

                if (options.codec === false || !self.audiocodec) {
                    delete result[pcKey].audiocodecIn;
                    delete result[pcKey].audiocodecOut;
                }
                if (options.codec === false || !self.videocodec) {
                    delete result[pcKey].videocodecIn;
                    delete result[pcKey].videocodecOut;
                }
            }
        }

        // options: an object with one or more of these attributes:
        // "interval" should be supplied if other than 1000 (1s).
        // "candidates" should set to false if candidates list is not needed.
        // "codec" should be set to false if videocodec information is not needed.
        function calculateMediaQualityMetrics(statsLast, callback, options) {
            options = options || {};
            var peerConnectionsData = {};
            var interval = options.interval === undefined ? 1000 : options.interval;
            var now = new Date().getTime();
            statsSetLocalPeerConnectionData(peerConnectionsData);
            statsSetRemotePeerConnectionData(peerConnectionsData, interval, now);

            var peerConnectionsKeys = Object.keys(peerConnectionsData);
            statsCleanObsoleteKeys(statsLast, peerConnectionsKeys);

            var result = {};

            var storeStatsFor = function (pcKey, pc, result_or_callback, completed_callback) {
                // new style standards based API
                pc.getStats(null)
                    .then(function (pcReports) {
                        if (options.sendstats) {
                            var pcData = peerConnectionsData[pcKey];
                            var customKey;
                            if (pcData.direction === 'send' && pcData.media === 'video') {
                                customKey = pcKey.endsWith('-screen') ? 'screen' : 'video';
                            } else if (pcData.direction === 'recv' && pcData.media === 'video') {
                                var userId = pcKey.split('-')[0];
                                customKey = 'video-' + userId;
                                // TODO: won't work for refactorPublisherId
                                if (self.isScreenshareId(parseInt(userId) || 0)) {
                                    customKey = 'screen-' + userId;
                                }
                            } else if (pcData.media === 'audio') {
                                customKey = 'audio';
                            }

                            if (customKey) {
                                setTimeout(function () {
                                    self.sendStatsExternal(customKey, pc, pcReports, pcData.start, pcData.plugin);
                                });
                            }
                        }

                        setTimeout(function () {
                            if (typeof result_or_callback === 'function') {
                                var reports = [];
                                pcReports.forEach(function (report) {
                                    reports.push(JSON.parse(JSON.stringify(report)));
                                });
                                result_or_callback(pcKey, { reports: reports });
                                if (completed_callback) {
                                    completed_callback();
                                }
                                return;
                            }

                            var stats = statsGetStatsFromPConnectionReport(pcReports, options);
                            statsSetResultObj(stats, pc, pcKey, statsLast, options, result_or_callback);
                            statsLast[pcKey] = stats;
                            if (completed_callback) {
                                completed_callback();
                            }
                        });
                    })
                    .catch(function (error) {
                        if (typeof result_or_callback === 'function') {
                            result_or_callback(pcKey, null);
                        }
                        if (completed_callback) {
                            completed_callback();
                        }
                    });
            };

            if (!statsLast) {
                var remaining = peerConnectionsKeys.slice(0);
                var value = {};
                var processResult = function (pcKey, reportsObj) {
                    if (value) {
                        var pcData = peerConnectionsData[pcKey];
                        if (pcData.direction === 'send' && pcData.media === 'video') {
                            reportsObj.simulcast = self.simulcastFlag;
                            reportsObj.bitrateDesired = Math.round(pcData.bitrate / 1000);
                            value[(pcKey.endsWith('-screen') ? 'screen' : 'video') + 'Tx'] = reportsObj;
                        } else if (pcData.direction === 'recv' && pcData.media === 'video') {
                            reportsObj.simulcast = pcData.simulcast;
                            value['videoRx/' + pcKey.split('-')[0]] = reportsObj;
                        } else if (pcData.media === 'audio') {
                            value.audio = reportsObj;
                        }
                    }
                    if (remaining.length <= 0) {
                        if (callback) {
                            callback(value);
                        }
                    } else {
                        var index0 = remaining.shift();
                        storeStatsFor(index0, peerConnectionsData[index0].pc, processResult);
                    }
                };

                if (remaining.length > 0) {
                    var index_0 = remaining.shift();
                    storeStatsFor(index_0, peerConnectionsData[index_0].pc, processResult);
                } else {
                    if (callback) {
                        callback({});
                    }
                }
                return;
            }

            var inactives = [];
            var remainingCount = peerConnectionsKeys.length;
            peerConnectionsKeys.forEach(function (key) {
                var value = peerConnectionsData[key];
                if (value.pc && value.pc.getStats) {
                    storeStatsFor(key, value.pc, result, function () {
                        remainingCount--;
                        if (remainingCount <= 0 && callback !== undefined) {
                            statsFinalizeResult(
                                options,
                                peerConnectionsData,
                                inactives,
                                interval,
                                now,
                                result,
                                callback
                            );
                        }
                    });
                } else {
                    if (!value.pc) {
                        inactives.push(key);
                    }
                    remainingCount--;
                    if (remainingCount <= 0 && callback !== undefined) {
                        statsFinalizeResult(options, peerConnectionsData, inactives, interval, now, result, callback);
                    }
                }
            });

            if (callback === undefined) {
                return;
            }
        }

        function getAvailableBitrate(item) {
            if (item.candidatePairs && item.candidatePairs.length > 0) {
                let bitrateProperty = item.dir == 'outbound' ? 'availableOutgoingBitrate' : 'availableIncomingBitrate';
                let availableBitrate = item.candidatePairs
                    .map(function (pair) {
                        return pair[bitrateProperty] || 0;
                    })
                    .reduce(function (max, bitrate) {
                        return Math.max(max, bitrate);
                    }, 0);
                return availableBitrate;
            }
            return 0;
        }

        function statsFinalizeResult(options, peerConnectionsData, inactives, interval, now, result, callback) {
            var value = {};
            var indices = Object.keys(result);
            var audioEnergy = {};

            indices.concat(inactives).forEach(function (index1) {
                var item1 = result[index1] || {};
                var item2 = peerConnectionsData[index1];
                var interval0 = Math.min(interval, now - item2.start);

                const calculateJitterBufferDelay = function (item) {
                    return item.jitterBufferDelay === undefined ||
                        !item.jitterBufferEmittedCount ||
                        isNaN(item.jitterBufferDelay) ||
                        isNaN(item.jitterBufferEmittedCount)
                        ? ''
                        : Math.round((item.jitterBufferDelay * 1000) / item.jitterBufferEmittedCount);
                };

                if (item2.direction === 'send' && item2.media === 'video') {
                    var type = index1.endsWith('-screen') ? 'screen' : 'video';
                    var frameRate = interval0 ? Math.round(((item1.framesSent || 0) * 1000) / interval0) : 0;
                    if (options.fixframerate && type === 'video' && frameRate > 0 && self.simulcastFlag) {
                        if (frameRate >= 45 && frameRate < 75) {
                            frameRate = Math.round(frameRate / 2);
                        } else if (frameRate >= 75) {
                            frameRate = Math.round(frameRate / 3);
                        }
                    }
                    // in millisecond, upto one decimal point.
                    var encodeTime =
                        Math.round(
                            item1.framesEncoded ? ((item1.totalEncodeTime || 0) * 10000) / item1.framesEncoded : 0
                        ) / 10;

                    // skip frozen video check if simulcast toggle phase is not 'idle'
                    if (type != 'screen' && options.checkFrozen && interval0 == interval && self.mediapath != 'sfu') {
                        if (self.isSimulcastTogglePhaseIdle()) {
                            self.onFrozenVideoTxCheck(item1, frameRate);
                        } else if (self.isSimulcastTogglePhaseDone()) {
                            // next time we'll not skip frozen video check
                            self.markSimulcastTogglePhaseAsIdle();
                        }
                    }

                    if (self.brokenMediaPath.detect && options.checkPath && self.mediapath != 'sfu') {
                        self.onBrokenMediaPathCheck(type, item1, interval, interval0);
                    }

                    if (
                        (self.brokenMediaSource.detect || self.qualityBarsConfig.enabled) &&
                        options.checkSource &&
                        !(avDeviceService.isAudioDeviceBlocked() || avDeviceService.isVideoDeviceBlocked()) &&
                        self.mediapath != 'sfu'
                    ) {
                        self.onBrokenMediaSourceCheck(type, item1, interval, interval0);
                    }

                    value[type + 'Tx'] = {
                        codec: item1.videocodecOut || undefined,
                        packets: item1.packetsSent,
                        bitrate: interval0 ? Math.round(((item1.bytesSent || 0) * 8) / interval0) : 0,
                        bytes:
                            options.bytes === 'raw'
                                ? item1.bytesSentTotal || 0
                                : formatBytes(item1.bytesSentTotal || 0),
                        bitrateDesired: Math.round((item2.bitrate || 0) / 1000),
                        frameRate: frameRate,
                        frameWidth: item1.frameWidth || 0,
                        frameHeight: item1.frameHeight || 0,
                        fpsCapture: item1.fpsCapture !== undefined ? Math.round(item1.fpsCapture) : undefined,
                        simulcastFlag: self.simulcastFlag,
                        qpSum: item1.framesEncoded ? Math.round((item1.qpSum || 0) / item1.framesEncoded) : undefined,
                        firCount: item1.firCount || 0,
                        pliCount: item1.pliCount || 0,
                        nackCount: item1.nackCount || 0,
                        packetsLost: item1.sentPacketsLost || 0,
                        fractionLost: item1.fractionLost || 0,
                        qualityLimitationReason: item1.qualityLimitationReason || undefined,
                        qualityLimitationResolutionChanges: item1.qualityLimitationResolutionChanges || undefined,
                        encodeTime: encodeTime,
                        jitter: Math.round(1000 * (item1.sentJitter || 0)),
                        rttDelay: item1.rttDelay || 0,
                        rttDelayAvg: item1.rttDelayAvg || 0,
                        audioSource: item1.audioSource || undefined,
                        videoSource: item1.videoSource || undefined,
                        candidatePairs: item1.candidatePairs,
                        height: item1.height,
                        width: item1.width
                    };
                    value[type + 'Tx'].availableBitrate = getAvailableBitrate(value[type + 'Tx']);
                } else if (item2.direction === 'recv' && item2.media === 'video') {
                    if (!value.videoRx) {
                        value.videoRx = {};
                    }

                    var indexId = index1.split('-')[0];

                    if (self.mediapath == 'sfu') {
                        audioEnergy[indexId] = item1.totalAudioEnergy;
                    }

                    // in millisecond, upto two decimal point.
                    var decodeTime =
                        Math.round(
                            item1.framesDecoded ? ((item1.totalDecodeTime || 0) * 100000) / item1.framesDecoded : 0
                        ) / 100;

                    // if framesDecoded is 0 for full interval, log it. only for 10s interval stats.
                    var frozenReason = null; // reason for frozen video if any. One of no - F (frames), B (bytes), D (decode)
                    if (interval0 == interval && self.mediapath != 'sfu' && !self.pauseOnBackground.paused) {
                        frozenReason = self.onFrozenVideoRxCheck(
                            item1,
                            item2,
                            options.checkFrozen,
                            indexId,
                            index1,
                            decodeTime
                        );
                    }

                    value.videoRx[indexId] = {
                        displayname: item2.displayname,
                        codec: item1.videocodecIn || undefined,
                        packets: item1.packetsReceived,
                        bitrate: interval0 ? Math.round(((item1.bytesReceived || 0) * 8) / interval0) : 0,
                        bytes:
                            options.bytes === 'raw'
                                ? item1.bytesReceivedTotal || 0
                                : formatBytes(item1.bytesReceivedTotal || 0),
                        frameRate: interval0 ? Math.round(((item1.framesDecoded || 0) * 1000) / interval0) : 0,
                        frameWidth: item1.frameWidth || 0,
                        frameHeight: item1.frameHeight || 0,
                        simulcast: item2.simulcast,
                        spotlight: item2.spotlight,
                        packetsLost: item1.packetsLost || 0,
                        firCount: item1.firCount || 0,
                        pliCount: item1.pliCount || 0,
                        nackCount: item1.nackCount || 0,
                        decodeTime: decodeTime,
                        framesReceived: item1.framesReceived || 0,
                        framesDecoded: item1.framesDecoded || 0,
                        framesDropped: item1.framesDropped || 0,
                        candidatePairs: item1.candidatePairs,
                        jitterBufferDelay: calculateJitterBufferDelay(item1),
                        height: item1.height,
                        width: item1.width
                    };
                    value.videoRx[indexId].availableBitrate = getAvailableBitrate(value.videoRx[indexId]);

                    if (self.layoutPage && self.layoutPageReuse.enabled) {
                        value.videoRx[indexId].active = !!item2.pc; // so that it can display differently if not active.
                    }

                    // assume remote is simulcast2 if self is simulcast2 for simplicity.
                    if (self.bitrateLowConfig.type == 'substream' && interval0 == interval && self.mediapath != 'sfu') {
                        self.switchSimulcastOnLowBitrateIfNeeded(
                            indexId,
                            item2.simulcast && item2.simulcast[2],
                            value.videoRx[indexId].bitrate
                        );
                    }

                    if (frozenReason) {
                        // TODO: should this be not set for screen rx?
                        value.videoRx[indexId].frozenReason = frozenReason.substring(3, 4); // short form to reduce stats data.
                    }

                    // update frozen state in plugin for logging.
                    var feed = self.feeds[indexId];
                    const validFeed = feed && typeof feed === 'object' && feed.state;
                    const visibleFeed = !item2.minimized && !self.pauseOnBackground.paused;
                    if (validFeed && visibleFeed) {
                        // TODO: don't do for screen stream?
                        self.onFrozenVideoRxUpdate(
                            feed,
                            frozenReason,
                            options.checkFrozen && interval0 == interval,
                            indexId,
                            item1
                        );
                    }
                } else if (item2.media === 'audio') {
                    if (
                        (self.brokenMediaSource.detect || self.qualityBarsConfig.enabled) &&
                        options.checkSource &&
                        !(avDeviceService.isAudioDeviceBlocked() || avDeviceService.isVideoDeviceBlocked()) &&
                        self.mediapath != 'sfu'
                    ) {
                        self.onBrokenMediaSourceCheck('audio', item1, interval, interval0);
                    }

                    value.audioTx = {
                        codec: item1.audiocodecOut || undefined,
                        packets: item1.packetsSent,
                        bitrate: interval0 ? Math.round(((item1.bytesSent || 0) * 8) / interval0) : 0,
                        bytes:
                            options.bytes === 'raw'
                                ? item1.bytesSentTotal || 0
                                : formatBytes(item1.bytesSentTotal || 0),
                        fractionLost: item1.fractionLost || 0,
                        packetsLost: item1.sentPacketsLost || 0,
                        jitter: Math.round(1000 * (item1.sentJitter || 0)),
                        rttDelay: item1.rttDelay || 0,
                        rttDelayAvg: item1.rttDelayAvg || 0,
                        audioSource: item1.audioSource || undefined,
                        videoSource: item1.videoSource || undefined,
                        count: attendeeListService.getAttendeeList().length,
                        candidatePairs: item1.candidatePairs
                    };
                    value.audioTx.availableBitrate = getAvailableBitrate(value.audioTx);

                    value.audioRx = {
                        codec: item1.audiocodecIn || undefined,
                        packets: item1.packetsReceived,
                        bitrate: interval0 ? Math.round(((item1.bytesReceived || 0) * 8) / interval0) : 0,
                        bytes:
                            options.bytes === 'raw'
                                ? item1.bytesReceivedTotal || 0
                                : formatBytes(item1.bytesReceivedTotal || 0),
                        packetsLost: item1.packetsLost || 0,
                        jitter: Math.round(1000 * (item1.jitter || 0)),
                        jitterBufferDelay: calculateJitterBufferDelay(item1)
                    };
                    value.audioRx.availableBitrate = getAvailableBitrate(value.audioRx);
                }
            });

            if (options.flat) {
                var array = [];
                for (var key in value) {
                    var item = value[key];
                    if (key === 'audioTx') {
                        item.media = 'audio';
                        item.dir = 'outbound';
                        array.push(item);
                    } else if (key === 'audioRx') {
                        item.media = 'audio';
                        item.dir = 'inbound';
                        array.push(item);
                    } else if (key === 'screenTx') {
                        item.media = 'video';
                        item.dir = 'outbound';
                        item.screen = true;
                        array.push(item);
                    } else if (key === 'videoTx') {
                        item.media = 'video';
                        item.dir = 'outbound';
                        array.push(item);
                    } else if (key === 'videoRx') {
                        for (var att in item) {
                            var item3 = item[att];
                            item3.media = 'video';
                            item3.dir = 'inbound';
                            item3.attendee = att;
                            if (self.isScreenshareId(parseInt(att) || 0)) {
                                item3.screen = true;
                            }
                            array.push(item3);
                        }
                    }
                }
                value = array;
            }

            // When quality bar is enabled, calculate and set qualityBars in "value"
            if (self.qualityBarsConfig.enabled && options.qualityBar) {
                self.setQualityBarsAttrs(value);
            }

            callback(value);

            if (self.mediapath === 'sfu') {
                self.onMediaPathCheckTalkerStats(audioEnergy);
            }
        }

        function formatBytes(value) {
            if (value < 10000) {
                return value + ' B';
            } else if (value < 1000000) {
                return Math.round(value / 1000) + ' kB';
            } else {
                return Math.round(value / 10000) / 100 + ' MB';
            }
        }

        function onStatsTimeout() {
            if (self.statsTimeoutPending) {
                return; // do not call again, if previous hasn't returned yet.
            }

            self.statsTimeoutPending = true;
            self.calculateMediaQualityMetrics(self.statsLast, function (result) {
                self.statsTimeoutPending = false;
                self.statsResults = result;
                digest();
            });
        }

        // parse value as "name:value,name:value,..." and update config object.
        // if create is true, then also create new attributes if missing in the config object.
        function setConfigObjectFromCSV(config, value, options) {
            if (typeof value !== 'string' || value === 'true' || value === 'false') {
                return;
            }
            const attributes = getAttributesFromCSV(value);
            attributes.forEach(function (data) {
                let created = false,
                    existing = data.attr
                        ? data.obj && data.attr && config[data.obj] && config[data.obj][data.attr]
                        : data.obj && config[data.obj];

                if (options && options.create && existing === undefined) {
                    // create and initialize to null
                    created = true;
                    if (data.attr) {
                        if (config[data.obj] === undefined) {
                            config[data.obj] = {};
                        }
                        existing = config[data.obj][data.attr] = null;
                    } else {
                        existing = config[data.obj] = null;
                    }
                }

                if (existing !== undefined) {
                    var val = data.val;
                    if (created && existing === null) {
                        if (val === 'null') {
                            val = null;
                        } else if (val === 'true' || val === 'false') {
                            val = val == 'true';
                        } else if (isFloat(val)) {
                            val = parseFloat(val);
                        } // remains as string
                    } else if (typeof existing === 'boolean') {
                        if (options && options.convert) {
                            // only allow null, boolean or number.
                            if (val === 'null') {
                                val = null;
                            } else if (isFloat(val)) {
                                val = parseFloat(val);
                            } else {
                                // any other non-'true' string becomes false.
                                val = val == 'true';
                            }
                        } else {
                            val = val == 'true';
                        }
                    } else if (typeof existing === 'number') {
                        if (options && options.convert) {
                            // only allow null, number, or boolean.
                            if (val === 'null') {
                                val = null;
                            } else if (val === 'true' || val === 'false') {
                                val = val == 'true';
                            } else {
                                // number or NaN. never string
                                val = parseFloat(val);
                            }
                        } else {
                            val = parseFloat(val);
                        }
                    } else if (typeof existing === 'string' || existing === null) {
                        val = val == 'null' ? null : val;
                    }

                    if (data.attr) {
                        config[data.obj][data.attr] = val;
                    } else {
                        config[data.obj] = val;
                    }
                }
            });
        }

        // Return mapped objects from CSV
        function getAttributesFromCSV(str) {
            return str.split(',').map(function (nv) {
                let index = nv.indexOf(':');
                const name = index >= 0 ? nv.substring(0, index) : nv;
                const val = index >= 0 ? nv.substring(index + 1) : null;
                index = name.indexOf('.');
                const obj = index >= 0 ? name.substring(0, index) : name;
                const attr = index >= 0 ? name.substring(index + 1) : null;
                return { obj: obj, attr: attr, val: val };
            });
        }

        function isFloat(value) {
            return ('' + value).match(/^-?\d+\.?\d*$/);
        }

        function digest() {
            if (!$scope.$$phase) {
                $scope.$digest();
            }
        }
    }
]);
